export const getRelativeDate = (dateString) => {
  const now = new Date();
  const date = new Date(dateString);
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) return "1天内";
  if (diffDays >= 1 && diffDays <= 7) return "7天内";
  if (diffDays > 7 && diffDays <= 14) return "两周内";
  if (diffDays > 14 && diffDays <= 30) return "30天内";

  return date.toISOString().slice(0, 7); // yyyy-mm
};
